export const ImageLoaderError = Object.freeze({
    FAILED_READING_FILE: 0,
    FAILED_LOADING_FILE: 1,
    FAILED_READING_CLIPBOARD: 2,
    NO_IMAGE_COPIED_IN_CLIPBOARD: 3,
});